module.exports = __webpack_public_path__ + "static/PRO003_avatar-5231e104a652f275541f30d5be7a71a1.jpg";